
 // MISCELANEOS

import { LabelType, Options } from "@angular-slider/ngx-slider";
import { matches } from "lodash";
import { map } from "rxjs-compat/operator/map";

 export const SliderShow: Options = {
  floor: Math.floor(0), // inicio precio mas bajo
  ceil: Math.floor(0), // fin  precio mas bajo
  //  step: 5,
  translate: (value: number, label: LabelType): string => {
    switch (label) {
      case LabelType.Low:
        return "<b>Min:</b> $ " + Math.floor(value);
      case LabelType.High:
        return "<b>Max:</b> $ " + Math.floor(value);
      default:
        return "$" + value;
    }
  },
};


 // HOTEL

export function createMealsFilter(data: any[]) {
  const mealsMap = new Map();

  data.forEach((element: any) => {
    if (element.additionalInfo?.rooms) {
      element.additionalInfo.rooms.forEach((room: any) => {
        const boardName = room.room?.boardName?.toLowerCase().trim();
        if (!boardName) return;

        const normalizedBoardName = boardName
          .replace(/\s+/g, '')
          .replace(/[&_]/g, '')
          .replace('and', '');

        // Buscar el primer boardType que coincida
        const matchedBoard = BoardTypes.find(boardType =>
          boardType.matches.some(match => {
            const normalizedMatch = match.toLowerCase()
              .replace(/\s+/g, '')
              .replace(/[&_]/g, '')
              .replace('and', '');

            return normalizedBoardName.includes(normalizedMatch) ||
                   normalizedMatch.includes(normalizedBoardName) ||
                   normalizedBoardName === normalizedMatch;
          })
        );

        if (matchedBoard && !mealsMap.has(matchedBoard.key)) {
          mealsMap.set(matchedBoard.key, {
            key: matchedBoard.key,
            label: matchedBoard.label,
            matches: matchedBoard.matches
          });
        }
      });
    }
  });

  return Array.from(mealsMap.values());
}

 export const BoardTypes = [
  {
    key: 'breakfast',
    label: 'Con desayuno',
    matches: ['breakfast', 'bb', 'bed & breakfast','bed and breakfast', 'desayuno', 'con desayuno', 'buffet breakfast']
  },
  {
    key: 'no_breakfast',
    label: 'Sin desayuno',
    matches: ['no breakfast', 'nb', 'sin desayuno', 'room only','ROOM ONLY', 'ro', 'solo alojamiento', 'sólo alojamiento']
  },
  {
    key: 'half_board',
    label: 'Media pensión',
    matches: ['half board', 'hb', 'media pensión', 'media pension']
  },
  {
    key: 'full_board',
    label: 'Pensión completa',
    matches: ['full board', 'fb', 'pensión completa', 'pension completa']
  },
  {
    key: 'all_inclusive',
    label: 'Todo incluido',
    matches: ['all inclusive', 'ai', 'todo incluido']
  }
];

export function acomodationsFilter(data: any): any[] {
    const acomodationMap = new Map();

    data.forEach((element: any) => {
      if (element.additionalInfo?.rooms) {
        element.additionalInfo.rooms.forEach((room: any) => {
          room.room.roomBeds.forEach((bed: any) => {
            const bedName = bed?.bedType?.toLowerCase().trim();
            if(!bedName) return ;

            const normalizedBedName = bedName
              .replace(/\s+/g, '')
              .replace(/[&_]/g, '')
              .replace('and', '');

            const matchedBed = AcomodationTypes.find(acomodationType =>
              acomodationType.matches.some(match => {
                const normalizedMatch = match.toLowerCase()
                  .replace(/\s+/g, '')
                  .replace(/[&_]/g, '')
                  .replace('and', '');

                  return normalizedBedName.includes(normalizedMatch) ||
                    normalizedMatch.includes(normalizedBedName) ||
                    normalizedBedName === normalizedMatch;
              })
            )
              if(matchedBed && !acomodationMap.has(matchedBed.key)) {
                acomodationMap.set(matchedBed, {
                  key: matchedBed.key,
                  label: matchedBed.label,
                  matches: matchedBed.matches
                })
              }
          });
        });
      }
    });

    return Array.from(acomodationMap.values());
};

 export const AcomodationTypes = [
  {
    key: 'Mat',
    label: 'Matrimonial king/queen',
    matches: ['king', 'queen']
  },
  {
    key: '1',
    label: '1 cama twin/king',
    matches: [' twin', 'king']
  },
  {
    key: '2',
    label: '2 camas twin',
    matches: ['twin']
  },
  {
    key: '3',
    label: '3',
    matches: []
  },
  {
    key: '4',
    label: '4',
    matches: []
  }
];

export function createCancellationFilter(data: any[]) {
  const cancellationMap = new Map();

  data.forEach((element: any) => {
    if (element.additionalInfo?.rooms) {
      element.additionalInfo.rooms.forEach((room: any) => {
        const rateClass = room.room?.rateClass?.toUpperCase().trim();
        if (!rateClass) return;

        // Comparación exacta (más simple y segura)
        const matched = CancellationTypes.find(ct => ct.key === rateClass);

        if (matched && !cancellationMap.has(matched.key)) {
          cancellationMap.set(matched.key, {
            key: matched.key,
            label: matched.label,
            matches: matched.matches
          });
        }
      });
    }
  });

  return Array.from(cancellationMap.values());
}

 export const CancellationTypes = [
  {
    key: 'NR',
    label: 'No reembolsable',
    matches: ['NR']
  },
  {
    key: 'R',
    label: 'Reembolsable',
    matches: ['R']
  },
];


export function createAmenitiesFilter(data: any[]) {
  const amenitiesMap = new Map();

  data.forEach((element: any) => {
    if (element.additionalInfo?.amenities) {
      element.additionalInfo.amenities.forEach((amenity: any) => {
        const amenityName = amenity.amenity_name?.toLowerCase().trim();
        if (!amenityName) return;

        const normalizedAmenityName = amenityName
          .replace(/\s+/g, '')
          .replace(/-/g, '');

        // Buscar el primer grupo que coincida
        const matchedGroup = AmenityGroups.find(group =>
          group.matches.some(match => {
            const normalizedMatch = match.toLowerCase()
              .replace(/\s+/g, '')
              .replace(/-/g, '');

            return normalizedAmenityName.includes(normalizedMatch) ||
                   normalizedMatch.includes(normalizedAmenityName) ||
                   normalizedAmenityName === normalizedMatch;
          })
        );

        if (matchedGroup && !amenitiesMap.has(matchedGroup.key)) {
          amenitiesMap.set(matchedGroup.key, {
            key: matchedGroup.key,
            label: matchedGroup.label,
            matches: matchedGroup.matches
          });
        }
      });
    }
  });

  return Array.from(amenitiesMap.values());
}



export const AmenityGroups = [
  {
    key: 'piscina',
    label: 'Piscina',
    matches: [
      'piscina', 'piscina climatizada', 'piscina infinita', 'piscina temperada', 'piscina con vista',
      'piscina en la azotea', 'piscina en el techo', 'piscina cubierta', 'piscina descubierta',
      'pileta', 'alberca', 'pileta y bienestar',
      'pool', 'heated pool', 'infinity pool', 'rooftop pool', 'indoor pool', 'outdoor pool',
      'piscina aquecida', 'piscina infinita', 'piscina exterior', 'piscina interior',
      'piscine', 'piscine chauffée', 'piscine extérieure', 'piscine intérieure'
    ]
  },
  {
    key: 'estacionamiento',
    label: 'Estacionamiento',
    matches: [
      'estacionamiento', 'parking', 'parqueadero', 'aparcamiento', 'cochera',
      'free parking', 'private parking', 'public parking', 'garage',
      'estacionamento', 'estacionamento gratuito', 'vaga',
      'parking gratuit', 'parking privé', 'parking public'
    ]
  },
  {
    key: 'family-friendly',
    label: 'Hotel Familiar',
    matches: [
      'hotel familiar', 'ideal para familias', 'para toda la familia', 'ambiente familiar',
      'family-friendly', 'family hotel', 'kids welcome', 'child-friendly',
      'hotel para crianças', 'familiar', 'ideal para famílias',
      'hôtel familial', 'idéal pour les familles', 'enfants bienvenus'
    ]
  },
  {
    key: 'onlyAdults',
    label: 'Solo Adultos',
    matches: [
      'solo adultos', 'adults only', 'exclusivo adultos', 'solo mayores',
      'apto solo adultos', 'sin niños', 'child-free',
      'apenas adultos', 'somente adultos', 'hotel para adultos',
      'réservé aux adultes', 'adultes uniquement', 'hôtel sans enfants'
    ]
  },
  {
    key: 'apartamento',
    label: 'Apartamento',
    matches: [
      'apartamento', 'departamento', 'aparthotel', 'apart-hotel', 'residencia turística',
      'apartment', 'flat', 'suite', 'aparthotel', 'vacation rental',
      'apartamento turístico', 'apê', 'apart-hotel',
      'appartement', 'studio', 'résidence hôtelière'
    ]
  }
];

// TRASLADO

export function createVehicleTypes(data: any[]) {
  const vehicleTypesMap = new Map();

  data.forEach((element: any) => {
    const keyPart = element.groupKey.split('|')[1]?.toLowerCase().trim();
    if (!keyPart) return;

    const matchedType = VehicleTypes.find(vehicleType =>
      vehicleType.matches.some(match => {
        const normalizedMatch = match.toLowerCase();
        const normalizedKeyPart = keyPart.toLowerCase();

        // Coincidencias más flexibles
        return normalizedKeyPart.includes(normalizedMatch) ||
               normalizedMatch.includes(normalizedKeyPart) ||
               normalizedKeyPart.replace(/\s+/g, '') === normalizedMatch.replace(/\s+/g, '') ||
               normalizedKeyPart.replace(/-/g, '') === normalizedMatch.replace(/-/g, '');
      })
    );

    if (matchedType && !vehicleTypesMap.has(matchedType.key)) {
      vehicleTypesMap.set(matchedType.key, {
        key: matchedType.key,
        label: matchedType.label,
        matches: matchedType.matches
      });
    }
  });
  return Array.from(vehicleTypesMap.values());
}

export const VehicleTypes = [
  {
    key: 'sedan',
    label: 'Sedán',
    matches: ['sedan', 'sedán', 'berlina', 'sedanes']
  },
  {
    key: 'suv',
    label: 'SUV',
    matches: ['suv', 'todo terreno', 'todo-terreno', '4x4', 'jeep', 'todoterreno']
  },
  {
    key: 'minivan',
    label: 'Minivan',
    matches: ['minivan', 'mini van', 'van pequeña', 'monovolumen', 'miniván']
  },
  {
    key: 'van',
    label: 'Camioneta',
    matches: ['van', 'camioneta', 'todoterreno', 'furgoneta', 'furgón', 'van grande', 'vehículo comercial']
  },
  {
    key: 'minibus',
    label: 'Minibús',
    matches: ['minibus', 'mini bus', 'microbús', 'combi', 'minibuses']
  },
  {
    key: 'bus',
    label: 'Autobús',
    matches: ['bus', 'autobús', 'ómnibus', 'coach', 'autocar', 'bus grande', 'bus privado']
  },
  {
    key: 'luxury',
    label: 'Vehículo de lujo',
    matches: ['luxury', 'lujo', 'vehículo de lujo', 'vehículo premium', 'premium', 'alto nivel', 'alta gama']
  },
  {
    key: 'limousine',
    label: 'Limusina',
    matches: ['limousine', 'limusina', 'limo']
  },
  {
    key: 'pickup',
    label: 'Pickup',
    matches: ['pickup', 'camioneta pickup', 'pick-up', 'pick up', 'camioneta abierta']
  },
  {
    key: 'armored',
    label: 'Blindado',
    matches: ['blindado', 'vehículo blindado', 'auto blindado', 'coche blindado', 'camioneta blindada']
  }
];

export const typeTranslate = [
{
    key: 'private',
    label: 'Privado',
    matches: ['privado', 'privada', 'servicio privado', 'vehículo privado']
  },
  {
    key: 'regular',
    label: 'Regular / Compartido',
    matches: ['regular', 'compartido', 'servicio compartido', 'shuttle', 'transporte regular']
  }
]


 export const FiltersHotels = {
  popular: {
    breakfast: [0, "CONTINENTAL BREAKFAST", "-1", "boardName", false],
    breakfastNo: [0, "ROOM ONLY", "-1", "boardName", false],
    nr: [0, "NOR", "-1", "rateClass", false],
    wifi: false,
    others: false,
  },
  stars: [false, false, false, false],
  services: {
    breakfast: false,
    bulter: false,
    phoneFree: false,
    others: false,
  },
  zona: {
    beach: false,
    city: false,
    others: false,
  },
};


 // RENT-A-CAR
 export const FiltersRentacar = {
  category: {
    categoryArray: [],
    checkedArray: [],
    categoryCant: [],
    img: []
  },
  brand: {
    brandArray: [],
    checkedArray: [],
    brandCant: [],

  },
  type: {
    typeArray: [],
    checkedArray: [],
    typeCant: [],
  },
  lowPrice: 0,
  HighPrice: 0,

};

// EXPERIENCIA


export function createLanguageFilterTour(data: any[]) {
  const languageMap = new Map();

  data.forEach((element: any) => {
    element.additionalInfo?.tours?.options.forEach((option: any) => {
      if(option.language) {
        const keyPart = option.language.toLowerCase().trim();
        if (!keyPart) return;

        const matchedLanguage = languages.find(language =>
          language.matches.some(match => {
            const normalizedMatch = match.toLowerCase();
            const normalizedKeyPart = keyPart.toLowerCase();

            // Coincidencias más flexibles
            return normalizedKeyPart.includes(normalizedMatch) ||
                   normalizedMatch.includes(normalizedKeyPart) ||
                   normalizedKeyPart.replace(/\s+/g, '') === normalizedMatch.replace(/\s+/g, '') ||
                   normalizedKeyPart.replace(/-/g, '') === normalizedMatch.replace(/-/g, '');
          })
        );

        if (matchedLanguage && !languageMap.has(matchedLanguage.key)) {
          languageMap.set(matchedLanguage.key, {
            key: matchedLanguage.key,
            label: matchedLanguage.label,
            matches: matchedLanguage.matches
          });
        }
      }
    })
  });
  return Array.from(languageMap.values());
}

export const languages = [
  {
    key: 'english',
    label: 'Inglés',
    matches: ['english', 'inglés', 'ingles']
  },
  {
    key: 'spanish',
    label: 'Español',
    matches: ['castellano', 'español', 'espaniol', 'espanol', 'spanish']
  },
  {
    key: 'french',
    label: 'Francés',
    matches: ['frances', 'francés', 'french']
  },
  {
    key: 'german',
    label: 'Aleman',
    matches: ['aleman', 'alemán', 'german', 'deutche']
  },
  {
    key: 'italian',
    label: 'Italiano',
    matches: ['italian', 'italiano']
  },
  {
    key: 'portuguese',
    label: 'Portugues',
    matches: ['portuguese', 'portugués', 'portugues']
  },
];

export function createSessionsFilter(data: any[]) {
  const sessionsMap = new Map();

  data.forEach((element: any) => {
    element.additionalInfo?.tours?.options.forEach((option: any) => {
      if (option.sessions) {
        const sessions = Array.isArray(option.sessions) ? option.sessions : [option.sessions];

        sessions.forEach((session: string) => {
          if (session && typeof session === 'string') {
            const period = getTimePeriod(session);
            if (period) {
              // Usamos la hora original como key, pero agrupamos por periodo
              const key = period;
              if (!sessionsMap.has(key)) {
                sessionsMap.set(key, {
                  key: key,
                  label: getSessionLabel(key),
                  // Guardamos también las horas originales para referencia
                  originalHours: new Set()
                });
              }
              // Agregamos la hora original al set
              sessionsMap.get(key).originalHours.add(session);
            }
          }
        });
      }
    });
  });

  // Ordenar: mañana, tarde, noche
  const periodOrder: { [key: string]: number } = {
    'mañana': 1,
    'tarde': 2,
    'noche': 3
  };

  return Array.from(sessionsMap.values())
    .sort((a, b) => periodOrder[a.key] - periodOrder[b.key]);
}

/**
 * Determina el periodo del día basado en la hora
 */
function getTimePeriod(timeString: string): string {
  try {
    const [hours, minutes] = timeString.split(':').map(part => Number(part.trim()));

    if (isNaN(hours) || isNaN(minutes)) {
      return 'mañana';
    }

    if (hours < 12) {
      return 'mañana';
    } else if (hours < 19) {
      return 'tarde';
    } else {
      return 'noche';
    }
  } catch (error) {
    return 'mañana';
  }
}

/**
 * Obtiene la etiqueta para mostrar del periodo
 */
function getSessionLabel(period: string): string {
  const labels: { [key: string]: string } = {
    'mañana': 'Mañana',
    'tarde': 'Tarde',
    'noche': 'Noche'
  };
  return labels[period] || period;
}

export function createAmenitiesFilterTour(data: any[]) {
  const amenitiesMap = new Map();

  data.forEach((element: any) => {

    const amenities = element.additionalInfo?.tours?.amenities || [];

    if(amenities.length > 0) {
      amenities.forEach((amenity: any) => {

          const keyPart = amenity.description?.toLowerCase().trim();
          if (!keyPart) return;

          const matchedAmenity = amenityGroupsTours.find(amenity =>
            amenity.matches.some(match => {
              const normalizedMatch = match.toLowerCase();
              const normalizedKeyPart = keyPart.toLowerCase();

              // Coincidencias más flexibles
              return normalizedKeyPart.includes(normalizedMatch) ||
                     normalizedMatch.includes(normalizedKeyPart) ||
                     normalizedKeyPart.replace(/\s+/g, '') === normalizedMatch.replace(/\s+/g, '') ||
                     normalizedKeyPart.replace(/-/g, '') === normalizedMatch.replace(/-/g, '');
            })
          );

          if (matchedAmenity && !amenitiesMap.has(matchedAmenity.key)) {
            amenitiesMap.set(matchedAmenity.key, {
              key: matchedAmenity.key,
              label: matchedAmenity.label,
              matches: matchedAmenity.matches
            });
        }
      })
    }
  });
  return Array.from(amenitiesMap.values());
}

export const amenityGroupsTours = [
  {
    key: 'transfer',
    label: 'Traslado',
    matches: [
      'transporte', 'transport', 'bus', 'taxi', 'recogida', 'retorno', 'transfer', 'pickup', 'pick-up', 'traslado'
    ]
  },
  {
    key: 'wifi',
    label: 'Wifi',
    matches: [
      'wifi', 'wi-fi', 'internet'
    ]
  },
  {
    key: 'ticket',
    label: 'Entrada',
    matches: [
      'entrance', 'entrada', 'ticket'
    ]
  },
  {
    key: 'food',
    label: 'Comida/bebida',
    matches: [
      'comida', 'alimentación', 'restaurante', 'plato', 'degustaciones', 'breakfast', 'lunch'
    ]
  },
  {
    key: 'guide',
    label: 'Guía',
    matches: [
      'guía', 'guia', 'guide'
    ]
  },
  {
    key: 'tour',
    label: 'Tour/Excursión',
    matches: [
      'tour', 'excursión', 'actividad'
    ]
  },
  {
    key: 'hotel',
    label: 'Hotel/Alojamiento',
    matches: [
      'hotel', 'alojamiento', 'habitación'
    ]
  },
  {
    key: 'breakfast',
    label: 'Desayuno',
    matches: [
      'desayuno', 'tea'
    ]
  },
  {
    key: 'assistance',
    label: 'Asistencia',
    matches: [
      'asistencia'
    ]
  },
  {
    key: 'headphones',
    label: 'Auriculares/Audioguía',
    matches: [
      'auriculares', 'audioguia', 'audioguía'
    ]
  },
  {
    key: 'drink',
    label: 'Bebida',
    matches: [
      'bebida', 'beer', 'drink'
    ]
  },
  {
    key: 'cruise',
    label: 'Crucero/Barco',
    matches: [
      'crucero', 'ship', 'barco'
    ]
  }
];


//RENTACAR

export function createLuggageFilter(data:any[]){
  const luggageArray = new Map();

  data.forEach((car:any) => {

    const bagsQuantity = car.additionalInfo.carRental.bagsQuantity || 0;

    if(bagsQuantity >= 1){
      const matchedLuggage = luggageGroupFilter.find((luggage) => {
        return luggage.matches.includes(bagsQuantity);
    })

    if(matchedLuggage && !luggageArray.has(matchedLuggage.key)){
      luggageArray.set(matchedLuggage.key, {
        key: matchedLuggage.key,
        label: matchedLuggage.label,
        matches: matchedLuggage.matches,
      })
    }
  }
});
return Array.from(luggageArray.values());
}


export const luggageGroupFilter = [
  {
    key:'luggage-1',
    label: '1 Equipaje',
    matches:[1],
  },
  {
    key:'luggage-2',
    label: '2 Equipajes',
    matches:[2],
  },
  {
    key:'luggage-4',
    label: '3 Equipajes',
    matches:[3]
  },

]

export function createAcrissFilter(data:any[]){
  const acrissArray = new Map();

  data.forEach((car:any) => {
    const typeAcriss = car.additionalInfo.carRental.AcrissCode;

    if(typeAcriss){
      const matchesAcriss = acrissCategoryMap.find((acriss) => {
        return acriss.matches.includes(typeAcriss[0]);
      })

      if(matchesAcriss && !acrissArray.has(matchesAcriss.key)){
        acrissArray.set(matchesAcriss.key, {
          key: matchesAcriss.key,
          label:matchesAcriss.label,
          matches: matchesAcriss.matches,
          price: car.additionalInfo.carRental.totalPrice,
          image:car.additionalInfo.images[0].image,
          currency:car.additionalInfo.carRental.currency
        })
      }
    }
  });

  return Array.from(acrissArray.values());
}


export const acrissCategoryMap = [
  {
    key:'small',
    label: 'Pequeños',
    matches: ['M','N','E','H'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'medium',
    label: 'Medianos',
    matches: ['C','D','I','J'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'large',
    label: 'Grandes',
    matches: ['S','R','F','G'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'premium',
    label: 'Alta Gama',
    matches: ['P','U','L','W'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'suv',
    label: 'Camionetas',
    matches: ['F','P'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'Family',
    label: 'Familiar',
    matches: ['W','V'],
    price: 0,
    image:'',
    currency:''
  },
  {
    key:'sport',
    label: 'Deportivo',
    matches: ['L','S','T'],
    price: 0,
    image:'',
    currency:''
  },
]

const suplierContractRentACar: any[] = [];

export function createContractRentACar(data: any[]) {
  const suplierMap = new Map();

  data.forEach((car: any) => {
    const supplierName = car.additionalInfo.carRental.optionRates.suplier.name;
    const suplierLogo = car.additionalInfo.carRental.optionRates.suplier.img;
    if (supplierName && !suplierMap.has(supplierName)) {
      suplierMap.set(supplierName, {
        key: supplierName,
        label: supplierName,
        logo: suplierLogo,
        matches: [supplierName]
      });
    }
  });

  return Array.from(suplierMap.values());
}


export function createTransmisionFilter(data:any[]){
  const transmissionMap = new Map();

  data.forEach((car) => {
    const transmissionValue = car.additionalInfo.carRental.gearbox;

    if(transmissionValue){
      const matchesTransmission = transmissionCategoryMap.find((transmission) => {
        return transmission.matches.includes(transmissionValue);
      })

      if(matchesTransmission && !transmissionMap.has(matchesTransmission.key)){
        transmissionMap.set(matchesTransmission.key, {
          key: matchesTransmission.key,
          label: matchesTransmission.label,
          matches: matchesTransmission.matches
        })
      }
    }
  })

  return Array.from(transmissionMap.values());
}

export const transmissionCategoryMap = [
  {
    key:'automatic',
    label: 'Automático',
    matches:['automatic', 'auto']
  },
  {
    key:'manual',
    label: 'Manual',
    matches:['Manual']
  }
]

export function createDoorsFilter(data:any[]){
  const quantityDoorsMap = new Map();

  data.forEach((car) => {
    const doorsValue = car.additionalInfo.carRental.doors;

    if(doorsValue){
      const matchesDoors = quantityDoorsFilter.find((doors) => {
        return doors?.matches.includes(doorsValue);
      })

      if(matchesDoors && !quantityDoorsMap.has(matchesDoors.key)){
        quantityDoorsMap.set(matchesDoors.key, {
          key: matchesDoors.key,
          label: matchesDoors.label,
          matches: matchesDoors.matches
        })
      }
    }

  })

  return Array.from(quantityDoorsMap.values());
}


export const quantityDoorsFilter = [
    {
    key:'door-1',
    label:'1 puertas',
    matches: ['1']
  },,
  {
    key:'door-2',
    label:'2 puertas',
    matches: ['2']
  },
    {
    key:'door-3',
    label:'3 puertas',
    matches: ['3']
  },
  {
    key:'door-4',
    label:'4 puertas',
    matches: ['4']
  },
    {
    key:'door-5',
    label:'5 puertas',
    matches: ['5']
  },
]

// createQtyMaxPassenger()

export function createQtyMaxPassenger(data:any[]){
  const quantityPaxMap = new Map();

  data.forEach((car) => {
    const quantityPaxValue = car.additionalInfo.carRental.paxQuantity;

    if(quantityPaxValue){
      const matchesQuantityPax = quantityPaxFilter.find((doors) => {
        return doors?.matches.includes(quantityPaxValue);
      })

      if(matchesQuantityPax && !quantityPaxMap.has(matchesQuantityPax.key)){
        quantityPaxMap.set(matchesQuantityPax.key, {
          key: matchesQuantityPax.key,
          label: matchesQuantityPax.label,
          matches: matchesQuantityPax.matches
        })
      }
    }

  })

  return Array.from(quantityPaxMap.values());
}


export const quantityPaxFilter = [
    {
    key:'1',
    label:'1 pasajero',
    matches: ['1']
  },,
  {
    key:'2',
    label:'2 pasajeros',
    matches: ['2']
  },
    {
    key:'3',
    label:'3 pasajeros',
    matches: ['3']
  },
  {
    key:'4',
    label:'4 pasajeros',
    matches: ['4']
  },
    {
    key:'5',
    label:'5 pasajeros',
    matches: ['5']
  },
]
// ASISTENCIA

export function createModalityInsuranceFilter(data: any[]): any[] {
  const modalityMap = new Map();

  // Pre-procesar keywords para búsqueda más eficiente
  const keywordMap = new Map();
  modalityKeywords.forEach(modality => {
    modality.matches.forEach(keyword => {
      keywordMap.set(keyword.toLowerCase(), modality);
    });
  });

  data.forEach((insurance) => {
    const insuranceValue = insurance.insurances;

    if(insuranceValue && Array.isArray(insuranceValue)) {
      insuranceValue.forEach((insuranceItem) => {
        const upgradeValue = insuranceItem.plan?.upgrades;

        if(upgradeValue && Array.isArray(upgradeValue)) {
          upgradeValue.forEach((upgrade) => {
            const upgradeName = upgrade?.name?.toLowerCase() || '';

            // Buscar si el nombre contiene alguna keyword
            for (const [keyword, modality] of keywordMap.entries()) {
              if (upgradeName.includes(keyword)) {
                if (!modalityMap.has(modality.key)) {
                  modalityMap.set(modality.key, {
                    key: modality.key,
                    label: modality.label,
                    matches: modality.matches
                  });
                }
                break; // Encontramos una coincidencia, pasamos al siguiente upgrade
              }
            }
          });
        }
      });
    }
  });

  return Array.from(modalityMap.values());
};

 /** Palabras clave para identificar tipos de modalidades de seguros */
export const modalityKeywords = [
    {
    key: 'preExisting',
    label: 'Pre existencia',
    matches: ['preexistencia', 'preexistente', 'pre-existencia']
    },
    {
    key: 'pregnant',
    label: 'Embarazo',
    matches: ['embarazo', 'embarazada', 'gestación']
    },
    {
    key: 'travel',
    label: 'En viaje',
    matches: ['viaje', 'itinerario', 'itinerary', 'travel']
   },
  ];

export function createCoverageInsuranceFilter(data: any[]): any[] {



  return [];

};
export function createUpgradeInsuranceFilter(data: any[]): any[] {



  return [];

};

// VUELOS

function getFirstSegment(flight: any): any {
  return flight?.itinerary?.[0]?.options?.[0]?.segments?.[0];
}

function getLastSegment(flight: any): any {
  const segments = flight?.itinerary?.[0]?.options?.[0]?.segments || [];
  return segments[segments.length - 1];
}

function titleCaseCity(city: string): string {
  if (!city) return '';
  return city.toLowerCase().replace(/\b\w/g, (l: string) => l.toUpperCase());
}

export function createFlightAirlinesFilter(data: any[]): { key: string; label: string; matches: string[]; count: number }[] {
  const airlinesMap = new Map<string, { key: string; label: string; matches: string[]; count: number }>();

  data.forEach((flight: any) => {
    const airline = getFirstSegment(flight)?.airline;
    const code = airline?.code || flight?.fare?.validatingCarrier;
    if (!code) return;

    const entry = airlinesMap.get(code) || { key: code, label: airline?.name || code, matches: [code.toLowerCase()], count: 0 };
    entry.count++;
    airlinesMap.set(code, entry);
  });

  return Array.from(airlinesMap.values()).sort((a, b) => b.count - a.count);
}

export function createFlightStopsFilter(data: any[]): { key: string; label: string; count: number }[] {
  const buckets = [
    { key: 'directo', label: 'Directo', test: (stops: number) => stops === 0 },
    { key: 'unaEscala', label: '1 escala', test: (stops: number) => stops === 1 },
    { key: 'dosMasEscalas', label: '2 escalas o más', test: (stops: number) => stops >= 2 },
  ];

  return buckets
    .map(bucket => ({
      key: bucket.key,
      label: bucket.label,
      count: data.filter((flight: any) => {
        const segments = flight?.itinerary?.[0]?.options?.[0]?.segments || [];
        return bucket.test(segments.length - 1);
      }).length
    }))
    .filter(bucket => bucket.count > 0);
}

export function createFlightCabinClassFilter(data: any[]): { key: string; label: string; matches: string[]; count: number }[] {
  const cabinMap = new Map<string, { key: string; label: string; matches: string[]; count: number }>();

  data.forEach((flight: any) => {
    const cabinClass = getFirstSegment(flight)?.cabin?.class || flight?.fare?.brandName;
    if (!cabinClass) return;

    const key = cabinClass.toString().toLowerCase().trim();
    const entry = cabinMap.get(key) || { key, label: cabinClass, matches: [key], count: 0 };
    entry.count++;
    cabinMap.set(key, entry);
  });

  return Array.from(cabinMap.values());
}

export function createFlightDepartureAirportsFilter(data: any[]): { key: string; label: string; count: number }[] {
  const airportsMap = new Map<string, { key: string; label: string; count: number }>();

  data.forEach((flight: any) => {
    const departure = getFirstSegment(flight)?.departure;
    if (!departure?.airport) return;

    const cityLabel = departure.city ? `${titleCaseCity(departure.city)} ` : '';
    const entry = airportsMap.get(departure.airport) || { key: departure.airport, label: `${cityLabel}(${departure.airport})`, count: 0 };
    entry.count++;
    airportsMap.set(departure.airport, entry);
  });

  return Array.from(airportsMap.values());
}

export const FLIGHT_TIME_BUCKETS = [
  { key: 'madrugada', label: 'Madrugada', range: '(0:00 - 4:59)', icon: '🌙', from: 0, to: 5 },
  { key: 'manana', label: 'Mañana', range: '(5:00 - 11:59)', icon: '🌤️', from: 5, to: 12 },
  { key: 'tarde', label: 'Tarde', range: '(12:00 - 17:59)', icon: '☀️', from: 12, to: 18 },
  { key: 'noche', label: 'Noche', range: '(18:00 - 23:59)', icon: '🌜', from: 18, to: 24 },
];

function getHourFromDateTime(dateTime: string): number | null {
  const match = dateTime?.match(/T(\d{2}):/);
  return match ? Number(match[1]) : null;
}

export function getFlightTimeBucketKey(dateTime: string): string | null {
  const hour = getHourFromDateTime(dateTime);
  if (hour === null) return null;
  return FLIGHT_TIME_BUCKETS.find(bucket => hour >= bucket.from && hour < bucket.to)?.key || null;
}

export function createFlightTimeFilter(data: any[], type: 'departure' | 'arrival'): { key: string; label: string; range: string; icon: string; count: number }[] {
  return FLIGHT_TIME_BUCKETS
    .map(bucket => ({
      key: bucket.key,
      label: bucket.label,
      range: bucket.range,
      icon: bucket.icon,
      count: data.filter((flight: any) => {
        const segment = type === 'departure' ? getFirstSegment(flight) : getLastSegment(flight);
        const dateTime = type === 'departure' ? segment?.departure?.dateTime : segment?.arrival?.dateTime;
        return getFlightTimeBucketKey(dateTime) === bucket.key;
      }).length
    }))
    .filter(bucket => bucket.count > 0);
}

export function getFlightTotalDurationHours(flight: any): number {
  const totalSeconds = (flight?.itinerary || []).reduce(
    (sum: number, leg: any) => sum + (leg?.options?.[0]?.duration || 0), 0
  );
  return totalSeconds / 3600;
}

export const FLIGHT_ATTRIBUTE_TYPES = [
  { key: 'carryOn', label: 'Equipaje de mano incluido' },
  { key: 'checked', label: 'Equipaje en bodega incluido' },
  { key: 'refundable', label: 'Tarifa reembolsable' },
];

export function flightHasAttribute(flight: any, key: string): boolean {
  const segment = getFirstSegment(flight);
  switch (key) {
    case 'carryOn':
      return !!segment?.baggage?.carryOn;
    case 'checked':
      return (segment?.baggage?.checked || 0) > 0;
    case 'refundable':
      return !!flight?.fare?.cancelPolicy && flight.fare.cancelPolicy !== 'MDNT';
    default:
      return false;
  }
}

export function createFlightAttributesFilter(data: any[]): { key: string; label: string; count: number }[] {
  return FLIGHT_ATTRIBUTE_TYPES
    .map(attribute => ({
      key: attribute.key,
      label: attribute.label,
      count: data.filter((flight: any) => flightHasAttribute(flight, attribute.key)).length
    }))
    .filter(attribute => attribute.count > 0);
}

export function getFlightPrice(flight: any): number {
  return flight?.passengers?.[0]?.price?.total ?? flight?.price?.total ?? 0;
}
